class StoreSelector extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.renderLoading();
        this.loadStores();
        this.setSelectOnCartEvent();
        this.listenToVariationChange();
    }

    renderLoading() {
        // this.shadowRoot.innerHTML = `<p>Caricamento negozi...</p>`;
    }

    setSelectOnCartEvent() {
        // on theme:cart:change event if detail.cartCount > 0 enable select else disable select
        document.addEventListener('theme:cart:change', (event) => {
            const dropdown = this.shadowRoot.querySelector('.dropdown');
            if (!dropdown) return;
            if (event.detail.cartCount > 0) {
                // hide dropdown
                if (dropdown) { dropdown.style.display = 'none'; }
            } else {
                // show dropdown
                if (dropdown) { dropdown.style.display = 'block'; }
            }
        });
    }

    renderHtmlFilteredSelect(stores, inCartSelectedStore = null) {
        const selectors = {
            selectPlaceholder: 'data-selectplaceholder',
            inputPlaceholder: 'data-inputplaceholder'
        };

        const content = document.querySelector('.custom-select-block');

        const dropdown = document.createElement('div');
        dropdown.classList.add('dropdown');

        const dropdownContent = document.createElement('div');
        dropdownContent.id = 'storeHtmlDropdown';
        dropdownContent.classList.add('dropdown-content');

        const button = document.createElement('button');
        button.classList.add('dropbtn');
        button.textContent = content.getAttribute(selectors.selectPlaceholder); // You can customize this text
        button.onclick = () => this.toggleDropdown(dropdownContent, dropdown);

        const input = document.createElement('input');
        input.type = 'text';
        input.placeholder = content.getAttribute(selectors.inputPlaceholder);
        input.id = 'myInput';
        input.onkeyup = () => this.filterFunction(input, dropdownContent);

        dropdownContent.appendChild(input);

        // add onclick event to the entire dropdown not the content only
        dropdown.addEventListener('click', (event) => {
            if (!event.target.classList.contains('dropbtn') && !event.target.closest('.dropdown-content')) {
                this.toggleDropdown(dropdownContent, dropdown);
            }
        });

        stores.forEach(store => {
            const link = document.createElement('div');
            link.classList.add('gtm-store-link');
            link.innerHTML = `<strong>${store.name}</strong><br>${store.address}`;
            link.style.display = 'none';
            dropdownContent.appendChild(link);

            link.addEventListener('click', (event) => {
                event.preventDefault();
                const selectElement = this.shadowRoot.querySelector('select[name="store-selector"]');
                if (selectElement) {
                    this.triggerselectchange(selectElement, store.id);
                    this.toggleDropdown(dropdownContent, dropdown); // Close the dropdown after selection
                    button.innerHTML = `<strong>${store.name}</strong> ${store.address}`; // Update button text
                }
            });
        });

        if (inCartSelectedStore.select_disabled){
            if (dropdown) {
                dropdown.style.display = 'none';
            }
        }

        dropdown.appendChild(button);
        dropdown.appendChild(dropdownContent);
        this.shadowRoot.appendChild(dropdown);
    }

    toggleDropdown(dropdownContent, dropdown) {
        const isOpening = !dropdownContent.classList.contains("open");
        dropdownContent.classList.toggle("show");
        dropdownContent.classList.toggle("open");
        dropdown.classList.toggle("show");
        dropdown.classList.toggle("open");
        let mql = window.matchMedia("(width <= 749px)");
        if(dropdown.classList.contains('open') && mql.matches) {
            document.querySelector("body").style = "height: 100vh; overflow: hidden;";
        }else{
            document.querySelector("body").style = "";
        }

        if (isOpening) {
            const input = this.shadowRoot.querySelector('#myInput');
            if (input) {
                this.filterFunction(input, dropdownContent);
            }
        }
    }

    filterFunction(input, dropdownContent) {
        const filter = input.value.toLowerCase();
        const links = dropdownContent.getElementsByTagName("div");
        let foundVisibleLink = false;
        const isSearchEmpty = filter.trim() === '';

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            const txtValue = link.textContent || link.innerText;
            if (isSearchEmpty) {
                link.style.display = "none";
            } else {
                const matches = txtValue.toLowerCase().indexOf(filter) > -1;
                link.style.display = matches ? "" : "none";

                if (matches) {
                    foundVisibleLink = true;
                }
            }
        }
        if (isSearchEmpty) {
            dropdownContent.classList.add('options-hidden');
            dropdownContent.classList.remove('no-results-found');
        } else {
            dropdownContent.classList.remove('options-hidden');

            if (!foundVisibleLink) {
                dropdownContent.classList.add('no-results-found');
            } else {
                dropdownContent.classList.remove('no-results-found');
            }
        }
    }

    listenToVariationChange() {
        document.addEventListener('theme:product:variantchange', async (event) => {
            const selectedStore = await this.checkCartAttributes() || null;
            const addToCartButton = document.querySelector('form[id^="ProductForm--template--"] button[type="submit"]');
            const storedIdInput = document.querySelector('form[id^="ProductForm--template--"] input[name="attributes[stored_id]"]');
            if ((selectedStore && selectedStore.stored_id) || (storedIdInput && storedIdInput.value)) {
                if (addToCartButton) {
                    addToCartButton.disabled = false;
                }
            }else{
                if (addToCartButton) {
                    addToCartButton.disabled = true;
                }
            }
        });
    }

    renderSelect(stores, inCartSelectedStore = null) {
        // disabilita addtocart
        const addToCartButton = document.querySelector('form[id^="ProductForm--template--"] button[type="submit"]');
        if (addToCartButton) {
            addToCartButton.disabled = true;
        }

        const placeholderText = this.getAttribute('placeholder') || 'Seleziona uno store';

        const select = document.createElement('select');
        select.name = 'store-selector';
        select.classList.add('store-selector');

        const option = document.createElement('option');
        option.value = '';
        option.textContent = placeholderText;
        option.disabled = true;
        option.selected = true;
        select.appendChild(option);

        stores.forEach(store => {
            const option = document.createElement('option');
            option.value = store.id;
            option.textContent = `${store.name} - ${store.address}`;
            select.appendChild(option);
        });

        select.addEventListener('change', (event) => {
            const dropdown = this.shadowRoot.querySelector('.dropdown');
            const selectedStoreId = event.target.value;
            const selectedStore = stores.find(store => store.id === selectedStoreId);

            if (selectedStoreId) {
                event.target.classList.add('selected-option');
                addToCartButton.disabled = false;
            } else {
                event.target.classList.remove('selected-option');
                addToCartButton.disabled = true;
            }

            // abilita addtocart se il valore della selezione è valido
            if (addToCartButton && selectedStoreId) {
                event.target.classList.add('selected-option');
                addToCartButton.disabled = false;
            } else {
                event.target.classList.remove('selected-option');
                addToCartButton.disabled = true;
            }

            if (!selectedStore) return;

            // Trova la form con id che inizia per "ProductForm--template--"
            const productForm = document.querySelector('form[id^="ProductForm--template--"]');
            if (!productForm) return;

            // Rimuovi eventuali attributi precedenti
            const existingInputs = productForm.querySelectorAll('[data-store-attribute]');
            existingInputs.forEach(input => input.remove());

            // Crea e aggiungi gli input hidden con i dati dello store
            const attributes = {
                stored_id: selectedStore.id,
                stored_name: selectedStore.name,
                stored_address: selectedStore.address,
                stored_latitude: selectedStore.latitude,
                stored_longitude: selectedStore.longitude,
                stored_url: selectedStore.store_url,
                stored_phone: selectedStore.phone,
                stored_email: selectedStore.email
            };

            Object.entries(attributes).forEach(([key, value]) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = `attributes[${key}]`;
                input.value = value;
                input.setAttribute('data-store-attribute', 'true');
                productForm.appendChild(input);
            });
            // add selected store name and address near label description
            const storeSelectedDescription = document.querySelector('.custom-select-block .store-selected-description');
            if (storeSelectedDescription) {
                storeSelectedDescription.textContent = `${selectedStore.name}, ${selectedStore.address}`;
            }
        });


        this.shadowRoot.innerHTML = '';
        const style = document.createElement('style');
            style.textContent = `
                select.store-selector {
                    display: none; /* nascondi il select originale */
                }

                .dropdown {
                    position: relative;
                    display: inline-block;
                    width: 100%;
                    margin-top: 1em;
                    &.open {
                        @media (max-width: 749px) {
                            bottom: 0px;
                            left: 0px;
                            position: fixed;
                            display: flex;
                            height: 100vh;
                            z-index: 100000;
                            background-color: var(--underlay-bg);
                            flex-direction: column;
                            justify-content: flex-end;
                        }
                    }
                }

                .dropbtn {
                    text-align: left;
                }

                .dropdown input {
                    box-sizing: border-box;
                    width: 100%;
                    padding: 0.75em 1em;
                    border: none;
                    font-size: 16px;
                    background-color: #000;
                    color: #fff;
                }

                .dropdown-content {
                    display: none;
                    position: relative;
                    background-color: #A3A3A3;
                    min-width: 100%;
                    height: 55vh;
                    overflow-y: auto;
                    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
                    z-index: 99999;
                }
                .dropdown-content.options-hidden,
                .dropdown-content.no-results-found {
                    height: 10vh;
                }

                .dropdown-content div {
                    padding: 0.75em 1em;
                    text-transform: lowercase;
                    cursor: pointer;
                    color: #fff;
                    margin: 1em;
                    border-radius: 10px;
                    background-color: #333;
                }


                .dropdown-content.show {
                    display: block;
                    position: relative;
                    background-color: #000;
                    min-width: 100%;
                    min-height: 70vh;
                    overflow-y: auto;
                    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
                    z-index: 99;
                    @media (min-width: 750px) {
                        position: absolute;
                        min-height: auto;
                    }
                }

                /* stile base del dropdown */
                button.dropbtn {
                    width: 100%;
                    background-color: #1B1B1B;
                    color: #fff;
                    font-size: 1rem;
                    border: 1px solid #aaa;
                    border-radius: 2px;
                    padding: 0.75em 2.5em 0.75em 1em;
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    line-height: 1.2;
                    cursor: pointer;
                    position: relative;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-transform: lowercase;
                }

                /* freccetta custom */
                button.dropbtn {
                    background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
                    background-repeat: no-repeat;
                    background-position: right 0.75em center;
                    background-size: 1em;
                }

                select.store-selector:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            `;

        this.shadowRoot.appendChild(style);
        this.shadowRoot.appendChild(select);

        if (inCartSelectedStore.stored_id) {// imposta lo store desiderato
            this.triggerselectchange(select, inCartSelectedStore.stored_id);
        }
        if (inCartSelectedStore.select_disabled){
            select.disabled = true; // disabilita la selezione
            // nascosti il dropdown
            const dropdown = this.shadowRoot.querySelector('.dropdown');
            if (dropdown) {
                dropdown.style.display = 'none';
            }
        }
    }

    triggerselectchange(selectElement, store_id) {
        selectElement.value = store_id;
        const event = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(event);
    }

    async loadStores() {
        const cached = sessionStorage.getItem('storeObjPickup');
        const selectedStore = await this.checkCartAttributes() || null;

        if (cached) {
            this.renderSelect(JSON.parse(cached), selectedStore);
            this.renderHtmlFilteredSelect(JSON.parse(cached), selectedStore);
            return;
        }

        await this.fetchStores();
        const stores = sessionStorage.getItem('storeObjPickup');
        if (stores) {
            this.renderSelect(JSON.parse(stores), selectedStore);
            this.renderHtmlFilteredSelect(JSON.parse(stores), selectedStore);
        } else {
            this.shadowRoot.innerHTML = `<p>Errore nel caricamento dei negozi.</p>`;
        }
    }

    decodeHTMLEntities(str) {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    }

    async fetchStores() {
        const selectors = {
            URLSearchParams: 'data-param',
            totalPages: 'data-pages',
            dataStorePath: 'data-store-path'
        };

        const content = document.querySelector('.custom-select-block');
        const storeUrlParam = content.getAttribute(selectors.URLSearchParams);
        const storeTotalPages = parseInt(content.getAttribute(selectors.totalPages), 10);
        const storeDataPath = `/pages/${content.getAttribute(selectors.dataStorePath)}`;

        const stores = [];
        const promises = [];

        for (let i = 1; i <= storeTotalPages; i++) {
            const url = `${window.location.origin}${storeDataPath}?page=${i}&${storeUrlParam}=${i}&view=stores-list`;
            promises.push(
                fetch(url)
                    .then(response => response.text())
                    .then(text => {
                        try {
                            const decoded = this.decodeHTMLEntities(text);
                            const data = JSON.parse(decoded);
                            stores.push(...data.stores);
                        } catch (e) {
                            console.error('Errore parsing JSON:', e);
                            console.warn('Risposta ricevuta:', text);
                        }
                    })
                    .catch(console.error)
            );
        }

        await Promise.all(promises);

        // Salvataggio in sessionStorage
        sessionStorage.setItem('storeObj', JSON.stringify(stores));

        const pickupStores = stores.filter(store => store.is_in_store_pickup === true);
        sessionStorage.setItem('storeObjPickup', JSON.stringify(pickupStores));

        sessionStorage.setItem('storeObjIsoCode', window.Shopify?.locale || 'default');
    }

    async checkCartAttributes() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            const stored_id = cart.attributes?.stored_id || null
            console.log(cart);

            // Verifica che stored_id sia valorizzato
            const isStoredIdValid = stored_id !== null && stored_id !== undefined && stored_id !== '';

            // Verifica che il carrello abbia almeno un prodotto
            const hasProductsInCart = Array.isArray(cart.items) && cart.items.length > 0;


            return {
                'stored_id': isStoredIdValid && hasProductsInCart ? stored_id : null,
                'select_disabled': isStoredIdValid && hasProductsInCart
            }
        } catch (error) {
            console.error('Errore nel recupero del carrello:', error);
            return null;
        }
    }

}

customElements.define('store-selector', StoreSelector);
